<div class="bg-info" style="height: 100vh; width: 100%">
    <div class="container">
      <form class="text-center" style="padding-top: 4rem;" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm.value)">
        <div class="form-group" style="font-size: 500%;">
          <!-- <label for="exampleFormControlInput1">Team Code:</label> -->
          <img src="assets/hnl-login.png" width="75%"/>
          <input type="input" name="TeamCode" required minlength="4" maxlength="4" class="form-control text-uppercase text-center" id="exampleFormControlInput1" style=" font-size: 150%; font-family: 'Share Tech Mono', monospace;" ngModel>
        </div>
        <div class="form-group">
            <button type="submit" [disabled]="!loginForm.form.valid" 
            [className]="(!loginForm.form.valid) ? 'btn btn-secondary btn-lg btn-block' : 'btn btn-warning btn-lg btn-block'">Go!</button>


            
          <!-- <input type="submit" mid="exampleFormControlInput1"> 
          <a href="quest">GO!</a> -->
        </div>
        <div *ngIf="this.loginFail()" class="alert alert-danger">
        {{ loginError }}
        </div>
        <div *ngIf="this.loginWarn()" class="alert alert-info">
          {{ loginError }}
          </div>
    </form>
    </div>
  </div>
